import { z } from "zod"
import { issueDifficultyValues } from "~/lib/enums"

export const issueDifficultySchema = z.literal(issueDifficultyValues).nullable()

export const defaultDifficulties = [
	{ level: 1, label: "Not difficult" },
	{ level: 2, label: "Slightly difficult" },
	{ level: 3, label: "Moderately difficult" },
	{ level: 4, label: "Difficult" },
	{ level: 5, label: "Very difficult" }
] satisfies { level: (typeof issueDifficultyValues)[number]; label: string }[]

export const teamDifficultiesSchema = z
	.array(
		z.object({
			level: z.literal(issueDifficultyValues),
			label: z.string().trim().min(1).max(40)
		})
	)
	.min(1)
	.max(5)
	.superRefine((options, ctx) => {
		if (new Set(options.map((option) => option.level)).size !== options.length)
			ctx.addIssue({
				code: "custom",
				message: "Each difficulty level can only appear once"
			})
		if (
			new Set(options.map((option) => option.label.toLowerCase())).size !==
			options.length
		)
			ctx.addIssue({
				code: "custom",
				message: "Difficulty labels must be unique"
			})
	})
	.transform((options) => options.sort((a, b) => a.level - b.level))

export function difficultySettingsDraft(options = defaultDifficulties) {
	return defaultDifficulties.map((option) => {
		const saved = options.find((entry) => entry.level === option.level)
		return { ...(saved ?? option), enabled: !!saved }
	})
}

export function difficultyLabel(
	level: number | null,
	options = defaultDifficulties
) {
	if (level === null) return "None"
	return (
		options.find((option) => option.level === level)?.label ??
		defaultDifficulties.find((option) => option.level === level)?.label ??
		`Level ${level}`
	)
}
